import React from 'react';
import { Link } from 'react-router'
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import EditItemModal from './EditItemModal';
import { ensureKeyed } from 'utils';
import {Modal} from 'react-bootstrap';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import {sortIcon, sortInverse} from '../../utils/UriSorting'

// TODO : style-loader sucks:  import './styles/ManagedResourceList.scss';

const exist = (x) => !!x;

export default class ManagedResourceList extends React.Component {
  static propTypes = {
    items: PropTypes.array, // current page of items.  If undefined, fetchItems is called and page displays loading state
    fetchItems: PropTypes.func.isRequired, // Load items from redux state and/or fetch them if needed

    displayType: PropTypes.string.isRequired, // Display name for the type of items we're managing
    displayTypePlural: PropTypes.string, // Defaults to displayType with an s

    editForm: PropTypes.func, // React component to render for form body
    editModal: PropTypes.func, // React component to render edit modal
    editModalProps: PropTypes.object, // Props for the edit modal
    editModelPath: PropTypes.string,
    editModel: PropTypes.object,
    copyModel: PropTypes.func,


    updateItem: PropTypes.func, // (item) => dispatch whatever, return promise

    deleteItem: PropTypes.func,
    deleteModal: PropTypes.func,
    deleteModalProps: PropTypes.object, // Props for the delete modal

    reOrderItem: PropTypes.func, // (item, position) => return a promise that removes the item from the list and re-inserts it at its new position

    itemButtons: PropTypes.arrayOf(PropTypes.func), // ({item, deleteItem(), editItem(), setItemPending(), clearItemPending()}) => render a button or link.

    bulkActions: PropTypes.arrayOf(PropTypes.func), // ({items, deleteItems(), editItems(), setItemPending(), clearItemPending()}) => render a button or link.

    collectionButtons: PropTypes.arrayOf(PropTypes.func), // ({createItem}) => render a button or link.

    onSelect: PropTypes.func,

    columns: PropTypes.arrayOf(PropTypes.shape({
      header: PropTypes.oneOfType([
        PropTypes.string, // Name of field.
        PropTypes.func // (item) => html or string
      ]).isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string, // Name of field.
        PropTypes.func // (item) => html or string
      ]),
      className: PropTypes.func // (item, colIndex, isHeader) => string for className on the <td> cell
    })).isRequired,

    newItemTitle: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    editItemTitle: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    emptyListMessage: PropTypes.string,

    deleteConfirmButton: PropTypes.string,
    deleteConfirmTitle: PropTypes.string,
    deleteConfirmBody: PropTypes.func,
    deletingButton: PropTypes.string,

    loadItemForEdit: PropTypes.func, // (item) => do anything that needs to be done with the item before showing edit form (i.e. loading it into react-redux-form)

    tableClassName: PropTypes.string,
    rowClassName: PropTypes.func // (item) => string: class names to include on table rows

    // TODO : Paginate this eventually
  };

  static defaultProps = {
    itemsPerPage: 0,
    bulkActions: [],
    editModalProps: {},
    deleteModalProps: {},
    editModal: null,
    deleteModal: null,

    itemButtons: [
      ({item, editItem, displayType}) =>
        <a className="managed-list-item-action btn btn-xs btn-primary" onClick={() => editItem()} data-bs-toggle="tooltip" title={`Edit ${displayType}`}>
          <FontAwesome name="pencil"/>
        </a>,
      ({item, deleteItem, displayType}) =>
        <a className="managed-list-item-action btn btn-xs btn-danger" onClick={() => deleteItem()} data-bs-toggle="tooltip" title={`Delete ${displayType}`}>
          <FontAwesome name="times"/>
        </a>
    ],

    collectionButtons: [
      ({createItem, displayType}) => <a className="add-item-button" onClick={() => createItem()} data-bs-toggle="tooltip" title={`Add a new ${displayType}`}>
        <FontAwesome name="plus-circle"/>&nbsp; Add a new {displayType}
      </a>
    ],

    updateItem: (item) => Promise.resolve()
  };

  constructor() {
    super();

    this.state = {
      selected: [],
      pendingItems: {},
      loading: false,
      showEditForm: false,
      showCopyForm: false,
      pendingDelete: null,
      submitting: false
    }
  }

  displayTypePlural() {
    return this.props.displayTypePlural || `${this.props.displayType}s`
  }

  emptyListMessage() {
    return this.props.emptyListMessage ||
      `Sorry, there are no ${this.displayTypePlural()} available.`;
  }

  componentDidMount() {
    this.fetchItemsIfNeeded();
  }

  componentDidUpdate() {
    this.fetchItemsIfNeeded();
  }

  fetchItemsIfNeeded() {
    const {items, fetchItems} = this.props;
    const {loading} = this.state;

    if (!items && !loading) {
      this.setState({loading: true});
      fetchItems().then(() => {
        this.setState({loading: false});
      });
    }
  }

  setItemPending(item) {
    this.setState({
      pendingItems: {
        [item.id]: true
      }
    });

    return Promise.resolve();
  }

  clearItemPending(item) {
    this.setState({
      pendingItems: {
        [item.id]: false
      }
    });

    return Promise.resolve();
  }

  editItem(item){
    const { loadItemForEdit=()=>{} } = this.props;

    loadItemForEdit(item);

    this.setState({
      showEditForm: true
    });
  }


  copyItem(item){
    const { loadItemForEdit=()=>{} } = this.props;

    loadItemForEdit(item);

    this.setState({
      showCopyForm: true
    });
  }

  createItem() {
    this.editItem({});
  }

  deleteItem(item) {
    this.setState({
      pendingDelete: item
    });
  }

  confirmDeleteItem(item){
    this.setState({
      submitting: true
    });

    this.setItemPending(item)
      .then(() => this.props.deleteItem(item))
      .then(() => this.setState({
        pendingDelete: null,
        submitting: false
      }))
      .then(() => this.clearItemPending(item))
      .then(() => this.props.fetchItems())
      .catch(() => this.setState({
        submitting: false
      }));
  }

  cancelDeleteItem() {
    this.setState({
      pendingDelete: null
    });
  }

  hideEdit() {
    this.setState({
      showEditForm: false
    });

    return Promise.resolve();
  }


  hideCopy() {
    this.setState({
      showCopyForm: false
    });

    return Promise.resolve();
  }
  updateItem(item){
    return this.props.updateItem(item)
      .then(() => this.props.fetchItems());
  }

  handleRowSelect(row, isSelected) {
    const {onSelect} = this.props;

    const selected = Object.assign({}, this.state.selected, {
      [row]: isSelected
    });

    this.setState({selected});

    if (onSelect) {
      onSelect(row);
    }

    return true;
  }

  handleSelectAll(isSelected, rows) {
    const {onSelect} = this.props;

    var selected = {};
    rows.forEach((row) => selected[row] = true);

    this.setState({selected});

    if (onSelect) {
      Object.keys(selected).forEach((row) => onSelect(row));
    }

    return true;
  }

  reOrderItem(item, newPosition){
    const { reOrderItem } = this.props;

    this.setState({loading: true});

    reOrderItem(item, newPosition)
      .then(() => this.setState({loading: false}));
  }

  render(){
    const { items, onSort, sort } = this.props;


    if (this.state.loading || !items) {
      return <div className="loading"></div>;
    }

    const {itemButtons, bulkActions, collectionButtons} = this.props;
    const {onSelect} = this.props;
    const {showEditForm, showCopyForm} = this.state;
    const {editForm} = this.props;
    const {editModal : EditModal} = this.props;
    const {deleteModal : DeleteModal} = this.props;
    const {pendingDelete} = this.state;
    const {displayType} = this.props;
    const {submitting} = this.state;
    const {tableClassName, rowClassName} = this.props;

    const selectRow = bulkActions.some(exist) || onSelect ? {
        mode: 'checkbox',
        onSelect: this.handleRowSelect.bind(this),
        onSelectAll: this.handleSelectAll.bind(this)
      } : undefined;

    const {columns} = this.props;

    const { reOrderItem } = this.props;

    const DragHandle = SortableHandle(() => <span className="drag-handle">
      <FontAwesome name="reorder"/>
    </span>);

    const renderItem = (item, i) =>
      <tr key={`item_${i}`} className={`managed-list-item ${rowClassName ? rowClassName(item, i) : ''}`.trim()}>
        {columns.map((column, j) => {
          const {value} = column;

          const realValue = (value && typeof(value) === 'function') ? value(item) : item[value];

          return <td key={`item_${i}_${j}`} className={!!column.className ? column.className(realValue, j, false) : undefined }>
            {realValue}
          </td>
        })}

        <td className="managed-list-item-actions text-end">
          {this.state.pendingItems[item.id] ?
            <FontAwesome name="spinner" spin/>
            :
            itemButtons.map((button, j) =>
              button({
                item,
                displayType,
                setItemPending: () => this.setItemPending(item),
                clearItemPending: () => this.clearItemPending(item),
                deleteItem: () => this.deleteItem(item),
                editItem: () => this.editItem(item),
                copyItem: () => this.copyItem(item)

              })
            ).filter(exist).map(ensureKeyed(`item_${i}_button`))
          }
          {reOrderItem && <DragHandle/>}
        </td>
      </tr>;

    const SortableItem = SortableElement(({value, index}) => renderItem(value, index));
    const SortableList = SortableContainer(({items}) =>
      <tbody>
        {items.map((value, index) =>
          <SortableItem key={`item-${index}`} index={index} value={value} />
        )}
      </tbody>
    );

    const regularList = (items) =>
      <tbody>
        {items.map(renderItem)}
      </tbody>;

    return <div className="managed-list-page">
      { collectionButtons.some(exist) && <div className="managed-list-collection-actions">
        {
          collectionButtons.map((button, i) =>
            button({
              displayType,
              createItem: ()=>this.createItem()
            })
          ).filter(exist).map(ensureKeyed('collection_button'))
        }
      </div> }

      {items && items.length <= 0 &&
      <div className="managed-list-empty">
        {this.emptyListMessage()}
      </div>
      }

      {items && items.length > 0 &&
        <table className={`table table-hover ${tableClassName}`.trim()}>
          <thead>
          <tr>
              {columns.map((column, i) => {
                if (column.sortable && sort) {
                  return (
                    <th key={`header_${i}`} className={!!column.className ? column.className(null, 0, true) : undefined}>
                      <Link to={onSort(column.sortName, (sort.column === column.sortName) ? sortInverse(sort.order) : 'asc')}>
                        {column.header}
                      </Link>
                      {sortIcon(sort, column.sortName)}
                    </th>
                  )
                }
                else {
                  return (
                    <th key={`header_${i}`} className={!!column.className ? column.className(null, 0, true) : undefined}>
                      {typeof column.header === 'function' ? column.header() : column.header}
                    </th>
                  )
                }
            })}

            {itemButtons.some(exist) && <th></th>}
          </tr>
          </thead>
          {reOrderItem ? <SortableList
            items={items}
            helperClass="dragging-row"
            useDragHandle={true}
            onSortEnd={({oldIndex, newIndex}) => this.reOrderItem(items[oldIndex], newIndex)}
          /> : regularList(items)}
        </table>
      }

      { showEditForm &&
        (
            EditModal && <EditModal
              item={this.props.editModel}
              onClose={this.hideEdit.bind(this)}
              handleSubmit={(item) => this.updateItem(item)}
              {...this.props.editModalProps}
            />
          ||
            <EditItemModal
              body={editForm}
              onClose={this.hideEdit.bind(this)}
              handleSubmit={(item) => this.updateItem(item)}
              modelPath={this.props.editModelPath}
              editItemTitle={this.props.editItemTitle || `Edit ${displayType}`}
              newItemTitle={this.props.newItemTitle || `Create ${displayType}`}
            />
        )
      }

      {showCopyForm && <EditModal
        item={this.props.copyModel()}
        copy={true}
        onClose={this.hideCopy.bind(this)}
        handleSubmit={(item) => this.updateItem(item)}
        {...this.props.editModalProps}
      />}

      { pendingDelete &&
        (
            DeleteModal && <DeleteModal
              item={pendingDelete}
              onClose={this.cancelDeleteItem.bind(this)}
              handleSubmit={() => this.confirmDeleteItem(pendingDelete)}
              {...this.props.deleteModalProps}
            />

          ||

            <Modal animation={false} show backdrop='static' keyboard={false}>
              <Modal.Header>
                <Modal.Title>{this.props.deleteConfirmTitle || "Confirm Deletion"}</Modal.Title>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => this.cancelDeleteItem()}></button>
              </Modal.Header>

              <Modal.Body>
                {this.props.deleteConfirmBody ? this.props.deleteConfirmBody(pendingDelete) : `Are you sure you want to delete this ${displayType}?`}
              </Modal.Body>

              <Modal.Footer>
                <a onClick={() => this.cancelDeleteItem()} className="btn btn-light" disabled={submitting}>Cancel</a>
                {submitting ?
                  <a disabled={true} className="btn btn-danger"><FontAwesome name="spinner" spin/> {this.props.deletingButton || "Deleting..."}</a>
                  :
                  <a onClick={() => this.confirmDeleteItem(pendingDelete)} className="btn btn-danger"
                     disabled={submitting}>
                    {this.props.deleteConfirmButton || `Delete ${displayType}`}
                  </a>
                }
              </Modal.Footer>
            </Modal>
        )
      }

    </div>;
  }
}
